import React, { useEffect } from 'react';

import { useFormControlGroup } from '../../hooks';
import { FormControl } from '../form-control';
import { FormControlGroupProps } from './types';

export const FormControlGroupWrapper = ({
  state,
  children,
  ...props
}: FormControlGroupProps) => {
  const values = useFormControlGroup();

  useEffect(() => {
    if (state)
      values.setFormControlContext({
        components: {
          Input: {
            variant: state,
          },
          Select: {
            variant: state,
          },
        },
        state,
      });
  }, [state]);

  return <FormControl {...props}>{children}</FormControl>;
};
